/**
 * Get domain from URL
 *
 * @example
 * getDomainFromUrl("https://www.zhytomyr.com") // zhytomyr.com
 * getDomainFromUrl("www.zhytomyr.com") // zhytomyr.com
 *
 * @param url {string} - URL
 */
export const getDomainFromUrl = url => {
  if (url && url.includes('.')) {
    try {
      const parsedUrl = new URL(url.includes('://') ? url : "https://" + url);
      return parsedUrl.hostname.replace(/^www\./, '');
    } catch (e) {}
  }
  return '';
};

/**
 * Get domain from email
 * @example
 * getDomainFromEmail("zhytomyr@best.city") // best.city
 *
 * @param email {string} - Email
 */
export const getDomainFromEmail = email => {
  if (email) {
    try {
      var _email$split$;
      return (_email$split$ = email.split('@')[1]) != null ? _email$split$ : '';
    } catch (e) {}
  }
  return '';
};
//# sourceMappingURL=getDomain.js.map